import React from 'react';

import UserRegistrationContainer from '@src/components/user/registration/UserRegistrationContainer';

const UserRegistrationPage = () => <UserRegistrationContainer />;

export default UserRegistrationPage;
